
/* eslint-disable import/no-anonymous-default-export */

export default {
    s3: {
        REGION: process.env.REACT_APP_REGION,
        BUCKET: process.env.REACT_APP_BUCKET,
    },
    apiGateway_admin: {
        REGION: process.env.REACT_APP_REGION,
        URL: process.env.REACT_APP_API+'/admin',
    },
    apiGateway_admin_activities: {
        REGION: process.env.REACT_APP_REGION,
        URL: process.env.REACT_APP_API+'/admin-activities',
    },
    apiGateway_admin_domains: {
        REGION: process.env.REACT_APP_REGION,
        URL: process.env.REACT_APP_API+'/admin-domains',
    },
    apiGateway_admin_providers: {
        REGION: process.env.REACT_APP_REGION,
        URL: process.env.REACT_APP_API+'/admin-providers',
    },
    cognito: {
        REGION: process.env.REACT_APP_REGION,
        USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
        APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
        IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
    },

};